
define('text!templates/modules/member/group/edit/group-edit-form.html',[],function () { return '\n<div class="name-input"></div>\n    <div class="input-placeholder">\n      <div class="control-label-top">\n          <label id="parentGroupLabel" class="control-label label-to-top">Parent</label>\n      </div>\n    </div>\n<div id="group-menu"></div>\n';});

